// Which page of a PDF an agent `highlight_text` request lands on (MAR-382).
//
// `page` is OPTIONAL in the tool schema (shared/web-chat/tools.ts), so a request without one must
// still find its text: absent (or out of range), the whole document is searched in page order; given,
// it is only a hint — tried first, then the rest of the document, so a wrong page number from the
// model degrades to a slower search rather than a silent no-op. First match wins.

export function highlightPageOrder(page: number | null | undefined, totalPages: number): number[] {
  const all = Array.from({ length: Math.max(0, totalPages) }, (_, i) => i + 1)
  if (!page || page < 1 || page > totalPages) return all
  return [page, ...all.filter(p => p !== page)]
}

export async function findHighlightPage(
  page: number | null | undefined,
  totalPages: number,
  pageMatches: (pageNum: number) => Promise<boolean>,
): Promise<number | null> {
  for (const pageNum of highlightPageOrder(page, totalPages)) {
    if (await pageMatches(pageNum)) return pageNum
  }
  return null
}
